import React, {useEffect, useState} from "react";
import PropTypes, {InferProps} from "prop-types";
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import {usePersonView, usePrincipal, useQuote} from "@betrue/front/services";
import {Quote} from "@betrue/shared/interfaces";
import {QuoteListView} from "./quote-list.view";

export const QuoteListPropsTypes = {
  loginLabel: PropTypes.string,
  quoteRefLabel: PropTypes.string,
  amountUntaxeLabel: PropTypes.string,
  amountLabel: PropTypes.string,
  creationDateLabel: PropTypes.string,
  fileLabel: PropTypes.string,
  removeLabel: PropTypes.string,
  acceptLabel: PropTypes.string,
  stateLabel: PropTypes.string,
  partnerLabel: PropTypes.string,
  source: PropTypes.string,
  acceptQuoteConfirmText: PropTypes.string,
  cancelLabel: PropTypes.string,
  actionLabel:PropTypes.string,
  totalQuoteLabel: PropTypes.string,
  quoteSubmitter: PropTypes.string,
  declineLabel: PropTypes.string,

}
export type QuoteListProps = InferProps<typeof QuoteListPropsTypes>

export const QuoteList = (props: QuoteListProps) => {
  const [principal] = usePrincipal()
  const [viewPerson,] = usePersonView()
  const [quote, {acceptSupplierQuote, declineSupplierQuote}] = useQuote<Quote>()
  const [userId, setUserId] = useState<string>(null)

  const [quoteList, {supplierQuotes, deleteSupplierQuote, findAllQuotes}] = useQuote<Quote[]>()

  useEffect(() => {
    console.log(quoteList)

  }, quoteList)

  useEffect(() => {
    if (viewPerson?.id && userId !== viewPerson.id) {
      setUserId(viewPerson.id)
    }
  }, [viewPerson])

  useEffect(() => {
    if (props.source === 'all') {
      console.log('find all')
      findAllQuotes()
    }
  }, [userId])


  useEffect(() => {
    if (userId && props.source !== 'all') {
      supplierQuotes(userId)
    }

  }, [userId])


  const handleDeleteQuote = (quote: Quote) => {
    deleteSupplierQuote(quote.id)
  }

  const handleAcceptSupplierQuote = (quote: Quote) => {
    acceptSupplierQuote(quote.id)
  }

  const handleDeclineSupplierQuote = (quote: Quote) => {
    declineSupplierQuote(quote.id)
  }

  if (!quoteList || !principal || ! viewPerson) return (<></>)
  return (
    <>
      <QuoteListView  onDeclineQuote={handleDeclineSupplierQuote} onAcceptQuote={handleAcceptSupplierQuote} currentUser={principal} quotes={quoteList} {...props}
                     deleteQuote={handleDeleteQuote}/>
    </>
  );
}


QuoteList.propTypes = QuoteListPropsTypes
